;(function() {
  'use strict'

  angular.module('core.kits', [])
})()
